/*eslint-env browser*/
import $ from "jquery"

//************************ Loader types


let loaderTypes = {
    jpg:  "image",
    png:  "image",
    gif:  "image",
    bmp:  "image",
    html: "xhr",
    txt:  "xhr",
    css:  "xhr",
    glsl: "xhr",
    json: "json",
    mp3:  "audio"
}


function getUrlExt (url) {
    let withoutArgs = url.split("?").shift()
    return withoutArgs.split(".").pop().toLowerCase()
}


function getLoaderType (url) {
    let ext = getUrlExt(url)
    let type = loaderTypes[ext] || null
    if (!type) {
        throw new Error(`No loader type found for ${ext}`)
    }

    return type
}




//************************ Loaders


let loaders = {}


loaders.image = function (url, onLoad, onError) {
    let img = new Image()
    img.crossOrigin = "Anonymous"

    img.addEventListener("load", function (...args) {
        onLoad(img, ...args)
    })

    img.addEventListener("error", onError)

    img.src = url
}


loaders.xhr = function (url, onLoad, onError) {
    $.get(url, onLoad).fail(onError)
}


loaders.json = function (url, onLoad, onError) {
    loaders.xhr(url, function (...args) {
        if (typeof args[0] === "string") {
            args[0] = JSON.parse(args[0])
        }
        onLoad(...args)
    }, onError)
}


function getLoader (type) {
    let loader = loaders[type] || null
    if (!loader) {
        throw new Error(`No loader found for ${type}`)
    }

    return loader
}



//************************ Error


function defaultLoadError (url) {
    let loadError = new Error(`Could not load ${url}`)
    return function () {
        throw loadError
    }
}



//************************ Http loader API


function load (url, onLoad, onError) {
    let type   = getLoaderType(url)
    let loader = getLoader(type)

    loader(url, onLoad, onError || defaultLoadError(url))
}

Object.assign(load, loaders)

export default load

